// src/web/client/src/components/PageHeader.jsx
// One page header for the six pages: the title is the menu item's name, always.
import React from 'react';

export default function PageHeader({ title, subtitle, actions = null }) {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
        {subtitle ? <p className="text-gray-500 mt-1">{subtitle}</p> : null}
      </div>
      {actions}
    </div>
  );
}
